<template>
  <div class="cardHeader">
    <div class="drawer_header">
      <div class="header_title">
        {{ name }}
        <div class="bgIMg"></div>
      </div>
      <i v-if="!noclose" class="el-icon-close close" @click="closeDrawer"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardHeader",
  props: ["name", "noclose"],

  methods: {
    closeDrawer() {
      this.$emit("closeDrawer");
    },
  },
};
</script>

<style lang="scss" scoped>
.cardHeader {
  width: 100%;
  display: flex;
  flex-direction: column;
  .drawer_header {
    user-select: none;
    border-bottom: 0.125rem solid #eeeeee;
    height: 3.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.25rem;
    box-sizing: border-box;
    .close {
      cursor: pointer;
      user-select: none;
    }
    .header_title {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      .bgIMg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
  }
}
</style>